export default {
  // / <summary>
  // / Cân đối: 5. Cân đối, 10. BSMT
  // / </summary>
  Symmetrical: 5,
  Target: 10,
};
